import type { ReactNode } from 'react';

export const symbol_shelves: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M128.5-48.63Q120-57.25 120-70v-820q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h600v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v820q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q780-57.25 780-70v-50H180v50q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM180-509h110v-130q0-12.75 8.63-21.38Q307.25-669 320-669h160q12.75 0 21.38 8.62Q510-651.75 510-639v130h270v-271H180v271Zm0 329h270v-130q0-12.75 8.63-21.38Q467.25-340 480-340h160q12.75 0 21.38 8.62Q670-322.75 670-310v130h110v-269H180v269Zm170-329h100v-100H350v100Zm160 329h100v-100H510v100ZM350-509h100-100Zm160 329h100-100Z"
		/>
	</svg>
);
